import React, { useState, useEffect } from "react";
import "./FoodModal.css";
import Modal from "react-bootstrap/Modal";
import CloseIcon from "@mui/icons-material/Close";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useAuth } from "../../AuthContext";
import Axios from "axios";
import { useBaseUrl } from "../../ApiContext";
import { NumericFormat } from "react-number-format";

export default function FoodModal({
  mealData,
  show,
  onHideHandle,
  units,
  activeUnitId,
  onActiveUnitId,
  onSaveActions,
  activeMealName,
  shamsiDate,
  mainId,
  method,
  onSubmitted,
  editInitAmount,
}) {
  const { userToken } = useAuth();
  const baseUrl = useBaseUrl();
  const [mealAmountVal, setMealAmountVal] = useState(0);
  const [activeUnit, setActiveUnit] = useState(null);

  const handleShowCategoryModal = () => {
    onHideHandle();
    setMealAmountVal(0);
  };

  const handleActiveUnitId = (unitId) => {
    onActiveUnitId(unitId);
  };

  const handleDecrement = () => {
    if (mealAmountVal > 1 || mealAmountVal === "") {
      setMealAmountVal((prevValue) => {
        const newValue = prevValue > 0 ? prevValue - 1 : 0;
        return parseFloat(newValue.toFixed(2));
      });
    } else if (mealAmountVal <= 1) {
      setMealAmountVal(0);
    }
  };

  const handleIncrement = () => {
    setMealAmountVal((prevValue) => (prevValue || 0) + 1);
  };

  const handleValueChange = (values) => {
    const { floatValue } = values;
    setMealAmountVal(floatValue || 0);
  };

  const handleMealCalorieSave = async () => {
    try {
      let response;
      const postData = {
        amount: mealAmountVal,
        meal_name: activeMealName,
      };

      if (userToken && method === "add") {
        response = await Axios.post(
          `${baseUrl}/report/diet_plan/${shamsiDate}/${activeUnitId}/${mealData.id}/add`,
          postData,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
      } else if (userToken && method === "edit") {
        response = await Axios.post(
          `${baseUrl}/report/diet_plan/${activeUnitId}/${mealData.id}/${mainId}/edit`,
          postData,
          {
            headers: {
              Authorization: `Token ${userToken}`,
            },
          }
        );
      }
      if (response && response.status === 204) {
        onSaveActions();
        if (onSubmitted) {
          onSubmitted();
        }
      }
      setMealAmountVal(0);
    } catch (error) {
      console.log("Error during add/edit request", error);
    }
  };

  useEffect(() => {
    if (units && activeUnitId) {
      let targetUnit = units.filter((unit) => unit.id === activeUnitId)[0];
      setActiveUnit(targetUnit);
    }
  }, [units, activeUnitId]);

  useEffect(() => {
    if (method === "edit") {
      setMealAmountVal(editInitAmount);
    }
  }, []);

  return (
    <Modal
      className="mealCalorieModal"
      show={show}
      onHide={handleShowCategoryModal}
    >
      <Modal.Header className="mealCalorieModalHeader centeredFlex">
        <Modal.Title className="mealCalorieModalTitle">
          {mealData.name}
        </Modal.Title>
        <div className="centeredFlex">
          <img
            className="MealCalorieBreakfastIcon"
            src="/images/breakfast.svg"
            alt="breakfast"
          />
          <div
            className="mealCalorieModalClose centeredFlex"
            onClick={handleShowCategoryModal}
          >
            <CloseIcon className="mealCalorieModalCloseIcon" />
          </div>
        </div>
      </Modal.Header>
      <Modal.Body>
        <div className="mealCalorieBodyTop centeredFlex darkHorizontalBorder">
          <div className="mealCalorieImportAmount centeredFlex">
            <div
              onClick={handleIncrement}
              className="mealCaloriePlusBtn centeredFlex"
            >
              <AddIcon className="foodModalPlusIcon" />
            </div>
            <NumericFormat
              value={mealAmountVal}
              allowNegative={false}
              allowLeadingZeros={false}
              decimalSeparator="."
              decimalScale={2}
              fixedDecimalScale={false}
              thousandSeparator=""
              prefix=""
              suffix=""
              format={(value) => {
                if (value === "") return "";
                return parseFloat(value).toFixed(1);
              }}
              onValueChange={handleValueChange}
              style={{
                borderRadius: "0.375rem",
                border: "1px solid #333",
                color: "#ff4545",
                fontWeight: 700,
                fontSize: "0.6875rem",
                display: "flex",
                alignItems: "center",
                direction: "ltr",
                textAlign: "center",
                width: "4rem",
                height: "1.5rem",
                outline: "none",
              }}
            />
            <div
              onClick={handleDecrement}
              className={`mealCalorieMinusBtn centeredFlex`}
            >
              <RemoveIcon className="foodModalMinusIcon" />
            </div>
          </div>
          {activeUnit && (
            <div className="mealCalorieSelectedValueUnit centeredFlex">
              <span className="mealCalculatedCalorie">
                {(
                  mealAmountVal *
                  (activeUnit.calories_per_serving / activeUnit.serving)
                ).toFixed(2)}{" "}
                کالری
              </span>
            </div>
          )}
        </div>
        <div className="mealCalorieBodyUnits scroll centeredFlex darkHorizontalBorder">
          {units.map((unit) => (
            <button
              key={unit.id}
              className={`calorieUnitBtn ${
                unit.id === activeUnitId ? "activeUnitBtn" : ""
              }`}
              onClick={() => handleActiveUnitId(unit.id)}
            >
              {unit.unit_name}
            </button>
          ))}
        </div>
        <div className="mealCalorieBodyBottom">
          <ul className="nutritionalIngredients">
            {activeUnit &&
              [
                {
                  id: 1,
                  title: "کربوهیدرات",
                  amount:
                    mealAmountVal *
                    (activeUnit.carbohydrates_per_serving / activeUnit.serving),
                  color: "var(--pink)",
                },
                {
                  id: 2,
                  title: "چربی",
                  amount:
                    mealAmountVal *
                    (activeUnit.fat_per_serving / activeUnit.serving),
                  color: "var(--orange)",
                },
                {
                  id: 3,
                  title: "پروتئین",
                  amount:
                    mealAmountVal *
                    (activeUnit.protein_per_serving / activeUnit.serving),
                  color: "#4EBFD8",
                },
                {
                  id: 4,
                  title: "فیبر",
                  amount:
                    mealAmountVal *
                    (activeUnit.fiber_per_serving / activeUnit.serving),
                  color: "#d80077",
                },
              ].map((ingredient) => (
                <li key={ingredient.id} className="ingredient centeredFlex">
                  <div className="ingredientName">
                    <div style={{ backgroundColor: ingredient.color }}></div>
                    <span>{ingredient.title}</span>
                  </div>
                  <span className="ingredientAmount">
                    {Number.isInteger(ingredient.amount)
                      ? ingredient.amount.toFixed(1)
                      : ingredient.amount.toFixed(2)}
                  </span>
                </li>
              ))}
          </ul>
          <button
            className="mealCalorieSaveBtn"
            onClick={handleMealCalorieSave}
          >
            ذخیره
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
